import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { RhfFieldError, rhfMapper } from "../../../rhf";
import { date } from "../../../validator/date";
import React from 'react';
import { useController } from 'react-hook-form';
import { defaultDateFormat } from "../base";
import { InputDateBottom } from "./input-date-bottom.component";
export const RhfInputDateBottom = props => {
  const {
    rhf,
    errorMessage,
    input,
    inputRef
  } = props;
  const {
    dateFormat,
    maxDate,
    minDate
  } = input !== null && input !== void 0 ? input : {};
  const {
    field: {
      onChange,
      onBlur,
      value
    },
    fieldState: {
      error
    }
  } = useController(rhfMapper(rhf, _objectSpread(_objectSpread({
    valid: v => date.valid(v, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat)
  }, minDate ? {
    min: value => date.min(value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat, minDate)
  } : {}), maxDate ? {
    max: value => date.max(value, dateFormat !== null && dateFormat !== void 0 ? dateFormat : defaultDateFormat, maxDate)
  } : {})));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputDateBottom, _extends({
    ref: inputRef,
    onChange: onChange,
    onBlur: onBlur,
    value: value,
    error: Boolean(error)
  }, input)), /*#__PURE__*/React.createElement(RhfFieldError, {
    errorMessage: errorMessage,
    error: error
  }));
};